var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 10,
    style: {
      fill: "rgba(255,255,255,.24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.912 18A2.509 2.509 0 0 1 4.4 15.494v-.979l-3.1-.372a1.474 1.474 0 0 1-1.034-2.3 6.724 6.724 0 0 0 1.192-3.427l.2-3.22a3.848 3.848 0 0 1 3.833-3.6H6V.911a.911.911 0 0 1 1.823 0v.683h.508a3.847 3.847 0 0 1 3.833 3.6l.2 3.22a6.716 6.716 0 0 0 1.192 3.421 1.474 1.474 0 0 1-1.034 2.3l-3.106.372v.979A2.509 2.509 0 0 1 6.912 18zm-1.14-3.189v.683a1.139 1.139 0 0 0 2.279 0v-.683zm-.28-11.849a2.477 2.477 0 0 0-2.469 2.319l-.2 3.22a8.087 8.087 0 0 1-1.434 4.117.107.107 0 0 0 .075.167l3.407.408a17.163 17.163 0 0 0 2.042.122 17.148 17.148 0 0 0 2.042-.122l3.407-.408a.107.107 0 0 0 .085-.063.1.1 0 0 0-.01-.1A8.1 8.1 0 0 1 11 8.5l-.2-3.22a2.479 2.479 0 0 0-2.469-2.318z",
    transform: "translate(10.089 8)",
    style: {
      fill: "#fffefd"
    },
    "data-name": "Outline / Status /Notification"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifIcon);
export default __webpack_public_path__ + "static/media/notif-icon.3f43aca1c29e00194e557b8ffd6609fc.svg";
export { ForwardRef as ReactComponent };